import { OutDesignNode } from "../ast";
import { EltType } from "../pandoc";

export function isInlineType(type: EltType): boolean {
  switch(type) {
    case "Str":
    case "Emph":
    case "Strong":
    case "Strikeout":
    case "Underline":
    case "Superscript":
    case "Subscript":
    case "SmallCaps":
    case "Quoted":
    case "Cite":
    case "Code":
    case "Space":
    case "SoftBreak":
    case "LineBreak":
    case "Math":
    case "RawInline":
    case "Link":
    case "Image":
      return true;
  }
  return false;
}

export function isBlockType(type: EltType): boolean {
  switch(type) {
    case "Note":
    case "Plain":
    case "Para":
    case "LineBlock":
    case "CodeBlock":
    case "RawBlock":
    case "BlockQuote":
    case "OrderedList":
    case "BulletList":
    case "DefinitionList":
    case "Header":
    case "HorizontalRule":
    case "Table":
    case "Figure":
    case "Div":
      return true;
  }
  return false;
}

export function containsInlines(type: EltType): boolean {
  switch(type) {
    case "Emph":
    case "Strong":
    case "Strikeout":
    case "Underline":
    case "Superscript":
    case "Subscript":
    case "SmallCaps":
    case "Quoted":
    case "Cite":
    case "Link":
    case "Span":
    case "Plain":
    case "Para":
    case "Header":
      return true;
  }
  return false;
}

export function containsBlocks(type: EltType): boolean {
  switch(type) {
    case "Note":
    case "BlockQuote":
    case "Figure":
    case "Div":
      return true;
  }
  return false;
}

export function isList(type: EltType): boolean {
  switch(type) {
    case "BulletList":
    case "OrderedList":
      return true;
  }
  return false;
}

export function isContentOneLineBreak(node: OutDesignNode): boolean {
  if (node.type !== "Para") return false
  const children = node.children ?? []
  if (children.length !== 1) return false
  return children[0].type === "LineBreak"
}

/**
 * Recursively extract textual content from any OutDesignNode.
 */
export function stringifyNode(node: OutDesignNode | OutDesignNode[] | string | number | boolean | null | undefined): string {
  if (node == null) return ""

  // Primitive types
  if (typeof node === "string" || typeof node === "number" || typeof node === "boolean") {
    return String(node)
  }

  // Array of nodes
  if (Array.isArray(node)) {
    return node.map(stringifyNode).join("")
  }

  // Node with children
  if (node.children && Array.isArray(node.children)) {
    return node.children.map(stringifyNode).join("")
  }

  // Node with textual data
  if (node.data?.text != null) {
    return String(node.data.text)
  }

    // Handle Space and line breaks
  switch (node.type) {
    case "Space":
      return " "
    case "SoftBreak":
    case "LineBreak":
      return "\n" // might not work! Not sure.
  }

  // Otherwise, ignore attributes or unhandled node types
  return ""
}

export function textToInlines(text: string): OutDesignNode[] {
  let nodes : Array<OutDesignNode> = []
  // const splitted = text.split(/ |\n/); // might not work! Not sure.
  const regex = /( +|(\\n)|([^( |\\\n)]+))/gm
  const splitted = text.match(regex); // might not work! Not sure.

  splitted?.forEach( s => {
    if(s.match(/ +/)) {
      nodes.push({ type : "Space" })
    } else nodes.push({ type: "Str", data: { text: s } })
  })
  return nodes;
}

export function blockToInlines(node: OutDesignNode): OutDesignNode[] {
  if(containsBlocks(node.type)) {
    const inlines: OutDesignNode[] = []
    node.children?.forEach((blk) => {
      inlines.push(...blockToInlines(blk as OutDesignNode));
    })
    return inlines;
  } else {
    return node.children;
  }
}

export function mergeConsecutiveStr(inlines: OutDesignNode[]): OutDesignNode[] {
  const merged: OutDesignNode[] = []
  let buffer: OutDesignNode[] = []
  inlines.forEach(inline => {
    if(inline.type !== "Str"){
      if(buffer) {
        merged.push(mergeStr(buffer))
        buffer = []
      }
      merged.push(inline)
    } else buffer.push(inline)
  })
  if(buffer) merged.push(mergeStr(buffer))
  return merged
}

function mergeStr(strs: OutDesignNode[]): OutDesignNode {
  return {
    type: "Str",
    data: {
      text: (strs.map((s) => s.data?.text).join(""))
    }
  }
}